<template>
  <div class="firm-beSelected">
    <div class="be-selected">
      <elese-nav :pageNav="pageNav"></elese-nav>
      <el-divider></el-divider>
      <div class="title">入选企业</div>

      <div class="search-box">
        <el-form class="search-form flex-row" ref="form" :model="form" label-width="85px">
          <el-form-item label="企业名称：">
            <el-input class="frame" v-model="form.name" ></el-input>
          </el-form-item>

          <el-form-item label="行业分类：" >
            <el-select class="frame"
              v-model="form.classify"
              placeholder="请选择活动区域" >
                <el-option v-for="(item,index) in classifyList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属园区：">
            <el-select class="frame" v-model="form.garden" placeholder="请选择活动区域">
                <el-option v-for="(item,index) in GardenList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属地区：">
            <el-cascader class="frame"
              size="large"
              :options="options"
              v-model="selectedOptions"
              placeholder="请选择所属地区"
              @change="handleChange" />
          </el-form-item>

          <el-form-item label="入选年份：">
            <el-date-picker class="frame"
              v-model="form.year"
              value-format="yyyy"
              type="year"
              placeholder="请选择年">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button class="inquire" @click="onInquire">查询</el-button>
            <el-button class="reset" @click="resetBtn">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="search-table">
        <el-table :data="tableData" border style="width: 1161px" @cell-click="goDetail">
            <el-table-column fixed type="index" label="序号" width="50">
            </el-table-column>

            <el-table-column prop="name" label="企业名称" width="220">
              <template slot-scope="scope">{{ scope.row.name||'-' }}</template>
            </el-table-column>

            <el-table-column prop="industry" label="行业分类" width="220">
              <template slot-scope="scope">{{ scope.row.industry||'-' }}</template>
            </el-table-column>

            <el-table-column prop="foundation_date" label="成立日期" width="120">
              <template slot-scope="scope">{{ scope.row.foundation_date||'-' }}</template>
            </el-table-column>

            <el-table-column
                prop="registry_capital"
                label="注册资本(万)"
                width="120"
            >
              <template slot-scope="scope">{{ scope.row.registry_capital||'-' }}</template>
            </el-table-column>

            <el-table-column prop="basementname" label="所属园区" width="180">
              <template slot-scope="scope">{{ scope.row.basementname||'-' }}</template>
            </el-table-column>

            <el-table-column prop="district" label="所属地区" width="150">
              <template slot-scope="scope">{{ scope.row.district||'-' }}</template>
            </el-table-column>

            <el-table-column prop="relate_year" label="入选年份" width="100">
              <template slot-scope="scope">{{ scope.row.relate_year||'-' }}</template>
            </el-table-column>

        </el-table>
      </div>
      <!-- <paging :totalPage="totalPage"
          :pageSize="size"
          :CurrentPage="page"
          @curentPage="handleCurrentChange">
      </paging> -->
      <paging :totalPage="totalPage"
        :pageSize="size"
        :CurrentPage="page"
        @curentPage="handleCurrentChange">
      </paging>

    </div>
    <return-top></return-top>
  </div>
</template>

<script>
import EleseNav from '@/components/active/eleseNav.vue'
import Paging from '@/components/paging.vue'
import { regionDataPlus, CodeToText } from 'element-china-area-data' // 省市区带‘全部’三级联动选择
import ReturnTop from '../../components/returnTop.vue'
export default {
  name: 'firmBeSelected',
  props: {},
  components: {
    EleseNav,
    Paging,
    ReturnTop
  },

  data () {
    return {
      pageNav: {
        firstName: '企业评选',
        secondName: '入选企业',
        path: '/firmElect'
      },
      classifyList: [], // 所有行业分类
      GardenList: [], // 所属园区
      options: regionDataPlus, // 省市区带‘全部’三级联动选择
      selectedOptions: [],
      form: {
        name: null, // 企业名称
        classify: null, // 行业分类
        garden: null, // 所属园区
        area: null, // 所属地区
        year: null // 入选年份
      },
      tableData: [], // 表格数据
      totalPage: 0, // 总页数
      page: 1, // 默认页码
      size: 10 // 每页数据条数
    }
  },
  created () {
    this.getFirmBeSelected()
    this.getClassify()
    this.getGardenData()
  },
  mounted () {
    console.log(111111)
    document.documentElement.scrollTop = 0

    this.$parent.activeIndex = '4'
  },
  methods: {
    // 获取行业分类数据
    async getClassify () {
      try {
        const res = await this.$get(this.$url.activity.firmClassify)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.classifyList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 获取所属园区数据
    async getGardenData () {
      try {
        const res = await this.$get(this.$url.activity.firmGarden)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.GardenList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 全国省市区三级联动
    handleChange () {
      var loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]] + '-'
      }

      const locArray = loc.split('-')

      const newLocArray = locArray.filter((item) => {
        return item !== '全部' && item !== '市辖区' && item !== ''
      })

      this.form.area = newLocArray.join('-')
    },

    // 获取入选企业数据
    async getFirmBeSelected () {
      try {
        const res = await this.$post(this.$url.activity.FirmBeSelectedData, {
          basementName: this.form.garden,
          companyName: this.form.name,
          district: this.form.area,
          industry: this.form.classify,
          year: this.form.year,
          page: this.page,
          size: this.size
        })
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.tableData = data.records
          this.tableData.forEach((item) => {
            item.foundation_date = item.foundation_date.split(' ')[0]
          })
          this.totalPage = data.total

          if (this.form.area === '') {
            this.form.area = null
          }
          // console.log(res)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 按条件查询
    onInquire () {
      this.page = 1
      this.getFirmBeSelected()
    },

    // 重置
    resetBtn () {
      this.page = 1
      this.form.garden = null
      this.form.name = null
      this.form.area = null
      this.form.classify = null
      this.form.year = null
      this.selectedOptions = []
      this.getFirmBeSelected()
    },

    // 分页功能
    handleCurrentChange (page) {
      this.page = page
      this.getFirmBeSelected()
    },

    // 跳转详情页
    goDetail (row, column, event) {
      this.$router.push({
        path: '/firmDetail',
        query: {
          id: row.id
        }
      })
      console.log(row)
    }

  }
}
</script>

<style scoped lang="less">
.firm-beSelected {
  width: 100%;
  min-height: 40px;
  background-color: #f5f5f5;
  margin-top: 8px;
  overflow: hidden;
}
.be-selected {
  width: 1200px;
  min-height: 40vh;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom:1px ;
  margin: 10px auto 100px;
}
.title {
  box-sizing: border-box;
  padding-left: 17px;
  margin: 22px 0;
  font-size: 20px;
  font-weight: 600;
  border-left: 4px solid #1076ec;
  border-radius: 2px 0 0 2px;
}
.search-box {
  box-sizing: border-box;
  padding: 0 20px;
  .search-form{
      display: flex;
      flex-wrap: wrap;
      font-size: 14px;
      .frame{
        width: 195px;
      }
      .inquire{
        background-color: #3056D9;
        color: #fff;
      }
      .reset{
        background-color: #F0F2F5;
        color: #000;
      }
  }
}
.search-table{
    box-sizing: border-box;
    padding: 0 18px 10px;
}
/deep/.is-leaf {
  background-color: #2B366C;
  font-size: 14px;
  color: #fff !important;
  text-align: center !important;
}
/deep/.el-table__row:nth-of-type(2n-1) {
  background-color: #fafafa;
}
/deep/.cell {
  text-align: center !important;
}

</style>
